import { useState } from "react";
import {
  Users, MonitorPlay, ShieldCheck, Megaphone, FileText, History, Settings, LayoutDashboard, Award,
} from "lucide-react";
import StatsTab from "./admin/StatsTab";
import ParticipantsTab from "./admin/ParticipantsTab";
import RoomsTab from "./admin/RoomsTab";
import ModeratorsTab from "./admin/ModeratorsTab";
import AnnouncementsTab from "./admin/AnnouncementsTab";
import MaterialsTab from "./admin/MaterialsTab";
import EditionsTab from "./admin/EditionsTab";
import SettingsTab from "./admin/SettingsTab";
import CertificadoTab from "./admin/CertificadoTab";

const TABS = [
  { id: "visao", label: "Visão Geral", icon: LayoutDashboard, testid: "admin-nav-tab-visao", component: StatsTab },
  { id: "inscritos", label: "Inscritos", icon: Users, testid: "admin-nav-tab-subscritores", component: ParticipantsTab },
  { id: "salas", label: "Salas & Vimeo", icon: MonitorPlay, testid: "admin-nav-tab-salas", component: RoomsTab },
  { id: "moderadores", label: "Moderadores", icon: ShieldCheck, testid: "admin-nav-tab-moderadores", component: ModeratorsTab },
  { id: "avisos", label: "Avisos", icon: Megaphone, testid: "admin-nav-tab-avisos", component: AnnouncementsTab },
  { id: "certificado", label: "Certificado", icon: Award, testid: "admin-nav-tab-certificado", component: CertificadoTab },
  { id: "materiais", label: "Materiais", icon: FileText, testid: "admin-nav-tab-materiais", component: MaterialsTab },
  { id: "edicoes", label: "Edições", icon: History, testid: "admin-nav-tab-edicoes", component: EditionsTab },
  { id: "evento", label: "Evento", icon: Settings, testid: "admin-nav-tab-evento", component: SettingsTab },
];

export default function Admin() {
  const [tab, setTab] = useState("visao");
  const Active = TABS.find((t) => t.id === tab)?.component || StatsTab;

  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-white mb-6">Ambiente de Gestão</h1>
      <div className="flex gap-2 overflow-x-auto pb-2 mb-6 -mx-1 px-1">
        {TABS.map(({ id, label, icon: Icon, testid }) => (
          <button key={id} onClick={() => setTab(id)} data-testid={testid}
            className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors ${
              tab === id ? "bg-[#F5A623] text-[#0C1530]" : "bg-[#142361] text-slate-300 hover:text-white border border-[#00C8FF]/20"
            }`}>
            <Icon size={15} /> {label}
          </button>
        ))}
      </div>
      <Active />
    </div>
  );
}
